import axios from "axios";
import { TOKEN } from "../config/storage";
import { API_URL } from "./apiurl";

const createNewReport = async (templateId) => {
  let data = JSON.stringify({
    query: `mutation { GenerateNewReportsBySecurityV2(templateId: ${templateId}) { success data } }`,
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: `${API_URL}/graphql`,
    headers: {
      "Content-Type": "application/json",
      Authorization: TOKEN,
    },
    data: data,
  };

  try {
    const response = await axios.request(config);
    console.log("Report creation response:", JSON.stringify(response.data));

    // Return the response data so the calling function can handle it
    return response.data?.data?.GenerateNewReportsBySecurityV2 || response.data;
  } catch (error) {
    console.error("Error creating report:", error);
    throw error; // Re-throw the error so the calling function can catch it
  }
};

// Export the function for use in other files
export default createNewReport;
